/**
 * UI-6b Task 10 — CsatScore config editor.
 *
 * Dropdown for window in days (7/14/30). Mirrors ConversationVolume's
 * editor for consistency.
 */
import type { JSX } from 'react'
import { Dropdown } from 'primereact/dropdown'
import type { CsatScoreConfig } from './Renderer.js'

interface Props {
  config: CsatScoreConfig
  onChange: (next: CsatScoreConfig) => void
}

const OPTIONS: Array<{ label: string; value: number }> = [
  { label: 'Last 7 days', value: 7 },
  { label: 'Last 14 days', value: 14 },
  { label: 'Last 30 days', value: 30 },
]

export function CsatScoreConfigEditor({ config, onChange }: Props): JSX.Element {
  return (
    <div className="flex flex-col gap-3" data-testid="csat-score-config-editor">
      <label className="flex flex-col gap-1 text-sm">
        <span className="font-medium">Time window</span>
        <Dropdown
          value={config.days}
          options={OPTIONS}
          onChange={(e): void => onChange({ ...config, days: e.value as number })}
          ariaLabel="CSAT time window in days"
          inputId="csat-score-days"
        />
      </label>
    </div>
  )
}
